/* Scoped visual treatment for the existing Shopify Forms custom-fit offer. */
(() => {
  const styleId = 'wcf-custom-fit-forms-style';
  const dialogSelector = '[data-sizing="form-wrapper"][aria-label="Get Your Custom Fit Savings"]';
  const assetScriptUrl = document.currentScript?.src
    || document.querySelector('script[src*="wcf-forms-custom-fit-popup.js"]')?.src;
  if (!assetScriptUrl) return;
  const modelImageUrl = new URL('wcf-forms-custom-fit-model-clean.png', assetScriptUrl).href;
  const css = `
    ${dialogSelector} {
      display: grid !important;
      grid-template-columns: minmax(0, 270px) minmax(0, 1fr) !important;
      width: min(780px, calc(100vw - 48px)) !important;
      max-width: none !important;
      min-width: 0 !important;
      max-height: calc(100dvh - 48px) !important;
      overflow: auto !important;
      border-radius: 18px !important;
      box-shadow: 0 24px 70px rgba(12, 22, 50, .24) !important;
    }

    ${dialogSelector} > div:first-child {
      display: block !important;
      grid-column: 1 !important;
      position: relative;
      min-height: 100% !important;
      background: linear-gradient(180deg, rgba(16, 31, 68, .05), rgba(16, 31, 68, .72)),
        url("${modelImageUrl}") center 35% / cover no-repeat;
    }

    ${dialogSelector} > div:first-child::before,
    ${dialogSelector} > div:first-child::after {
      position: absolute;
      left: 26px;
      right: 20px;
      color: #fff;
      font-family: Inter, Arial, sans-serif;
    }

    ${dialogSelector} > div:first-child::before {
      content: 'COZYFIT';
      top: 26px;
      font-size: 13px;
      font-weight: 800;
      letter-spacing: .18em;
    }

    ${dialogSelector} > div:first-child::after {
      content: 'MADE FOR\\A EVERY SHIFT';
      bottom: 30px;
      white-space: pre;
      font-size: 24px;
      font-weight: 800;
      line-height: 1.12;
      letter-spacing: -.02em;
    }

    ${dialogSelector} > div:nth-child(2) {
      grid-column: 2 !important;
      min-width: 0;
      padding: 42px 44px 34px !important;
      background: #fff;
    }

    ${dialogSelector} h2 {
      color: #121212 !important;
      font-size: 29px !important;
      font-weight: 750 !important;
      line-height: 1.15 !important;
      letter-spacing: -.035em !important;
      text-align: left !important;
    }

    ${dialogSelector} > div:nth-child(2) > section:first-child {
      text-align: left !important;
    }

    ${dialogSelector} > div:nth-child(2) > section:first-child p:first-child {
      margin: 13px 0 15px !important;
      color: #566078 !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;
    }

    ${dialogSelector} > div:nth-child(2) > section:first-child p:first-child strong {
      font-weight: 500 !important;
    }

    ${dialogSelector} > div:nth-child(2) > section:first-child p:not(:first-child) {
      margin: 0 0 7px !important;
      padding: 8px 13px !important;
      border-left: 3px solid #334fb4;
      border-radius: 0 8px 8px 0;
      background: #f3f6fd;
      color: #242833 !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1.35 !important;
      text-align: left !important;
    }

    ${dialogSelector} form {
      margin-top: 21px !important;
    }

    ${dialogSelector} input[type="text"],
    ${dialogSelector} input[type="email"] {
      border-radius: 10px !important;
      box-sizing: border-box !important;
      height: 56px !important;
      min-height: 56px !important;
    }

    ${dialogSelector} button[type="submit"] {
      box-sizing: border-box !important;
      height: 50px !important;
      min-height: 50px !important;
      padding: 0 15px !important;
      align-items: center !important;
      border-radius: 10px !important;
      background: #334fb4 !important;
      color: #fff !important;
      font-size: 15px !important;
      font-weight: 700 !important;
    }

    ${dialogSelector} button[type="submit"]:hover {
      background: #263e98 !important;
    }

    ${dialogSelector} > div:nth-child(2) > div:last-child {
      margin-top: 16px !important;
      color: #6c7485 !important;
      font-size: 11px !important;
      line-height: 1.5 !important;
      text-align: left !important;
    }

    @media (max-width: 699px) {
      ${dialogSelector} {
        display: block !important;
        width: min(430px, calc(100vw - 28px)) !important;
        max-height: calc(100dvh - 28px) !important;
        border-radius: 15px !important;
        border-top: 5px solid #334fb4;
      }

      ${dialogSelector} > div:first-child {
        display: none !important;
      }

      ${dialogSelector} > div:nth-child(2) {
        padding: 28px 25px 24px !important;
      }

      ${dialogSelector} h2 {
        padding-right: 16px;
        font-size: 23px !important;
      }

      ${dialogSelector} > div:nth-child(2) > section:first-child p:not(:first-child) {
        padding: 7px 11px !important;
        font-size: 13px !important;
      }
    }
  `;

  const watched = new WeakSet();
  let pageObserver;

  function install(root) {
    if (root.getElementById(styleId)) return true;
    if (!root.querySelector(dialogSelector)) return false;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.appendChild(style);
    pageObserver?.disconnect();
    return true;
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      const root = host.shadowRoot;
      if (!root || watched.has(root)) return;
      watched.add(root);
      if (install(root)) return;
      const rootObserver = new MutationObserver(() => {
        if (install(root)) rootObserver.disconnect();
      });
      rootObserver.observe(root, { childList: true, subtree: true });
    });
  }

  pageObserver = new MutationObserver(scan);
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
